import type { IGetPublicConsentParameters } from '../../types/PublicConsent.parameters';

export const factoryGetPublicConsentKey = (params: IGetPublicConsentParameters) => {
  return ['GET_PUBLIC_CONSENT', params.consent] as const;
};
